import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress, Container, Modal, Stack } from "@mui/material";
import { memo } from "react";
import { PageControls } from "../../PageControls";
export var Suspense360Loading = memo(function (_a) {
    var onClose = _a.onClose;
    return (_jsx(Modal, __assign({ open: true }, { children: _jsxs(Stack, __assign({ justifyContent: "center", alignItems: "center", sx: {
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                bgcolor: "secondary.dark",
                zIndex: "modal",
            } }, { children: [_jsx(Container, __assign({ maxWidth: false, sx: { minHeight: "100vh" } }, { children: _jsx(Stack, __assign({ flexDirection: "column", justifyContent: "space-between", alignItems: "flex-start", height: "100%", pt: 10 }, { children: _jsx(PageControls, { onClose: onClose }) })) })), _jsx(Stack, __assign({ position: "absolute" }, { children: _jsx(CircularProgress, {}) }))] })) })));
});
